import { render, staticRenderFns } from "./empty-placeholder.vue?vue&type=template&id=b2148282&scoped=true"
import script from "./empty-placeholder.vue?vue&type=script&lang=js"
export * from "./empty-placeholder.vue?vue&type=script&lang=js"
import style0 from "./empty-placeholder.vue?vue&type=style&index=0&id=b2148282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2148282",
  null
  
)

export default component.exports